var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewBlur(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "brxe-svg",
    id: "brxe-budbix",
    xmlns: "http://www.w3.org/2000/svg",
    width: 1440,
    height: 300,
    viewBox: "0 0 1440 718",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1658_25980)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 720.5,
    cy: -227.5,
    rx: 854.5,
    ry: 445.5,
    fill: "url(#paint0_linear_1658_25980)",
    fillOpacity: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1658_25980",
    x: -634,
    y: -1173,
    width: 2709,
    height: 1891,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 250,
    result: "effect1_foregroundBlur_1658_25980"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1658_25980",
    x1: -868.87,
    y1: -673,
    x2: 1637.72,
    y2: -1432.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#FA5560"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499028,
    stopColor: "#B14BF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D91FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewBlur);
export default __webpack_public_path__ + "static/media/new_blur.30bf2c87ceefe13db14a3f7ff6a02ee1.svg";
export { ForwardRef as ReactComponent };